import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardHomePage from './HomeDashboard';
import CreateSessionPage from './SessionCreation';
import CreateSetPage from './SetCreation';
import SetManagement from './SetManagement';
import SessionHistory from './SessionHistory';
import LoginPage from './LoginPage';
import ProtectedRoute from './ProtectedRoute';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <DashboardHomePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/sessions/new" 
            element={
              <ProtectedRoute>
                <CreateSessionPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/sessions" 
            element={
              <ProtectedRoute>
                <SessionHistory />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/sets" 
            element={
              <ProtectedRoute>
                <SetManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/sets/new" 
            element={
              <ProtectedRoute>
                <CreateSetPage />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
